// research-defender.component.ts
import { Component, OnInit } from '@angular/core';
import { RdService } from 'src/app/services/rd.service';
import { RdTokenService } from 'src/app/services/rd-token.service';
import { rdResponse, Respondent, Survey } from 'src/app/models/rd-models';

@Component({
  selector: 'app-research-defender',
  templateUrl: './research-defender.component.html',
  styleUrls: ['./research-defender.component.css']
})
export class ResearchDefenderComponent implements OnInit {
  title = 'Research Defender - RespondentTracking API Demo';
  respondent: Respondent | undefined;
  surveys: Survey[] = [];
  token: string;

  constructor(private rdService: RdService, private rdTokenService: RdTokenService) { }

  ngOnInit(): void {
    // const surveyNumber = '20230322_001';
    // const surveySession = 'T__20230322_001';
    // this.rdService.searchRespondents(surveyNumber, surveySession).subscribe(
    //   (response: rdResponse) => {
    //     console.log('API Response:', response);
    //     this.respondent = response.rdSearch.Respondent;
    //     this.surveys = response.rdSearch.Surveys;
    //     console.log('Respondent:', this.respondent);
    //     console.log('Surveys:', this.surveys);
    //   },
    //   error => {
    //     console.error('Error:', error);
    //   }
    // );

    // //forToken
    // this.rdTokenService.getToken().subscribe(
    //   (token: string) => {
    //     this.token = token;
    //     console.log('TokenInfo:', this.token)
    //   },
    //   (error: any) => {
    //     console.error('Error fetching token', error);
    //   }
    // );
  }



}
